/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Charakteristika`
};

const da_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Egenskab`
};

const de_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Eigenschaft`
};

const en_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Characteristic`
};

const es_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Característica`
};

const fr_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Caractéristique`
};

const hu_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Jellemzés`
};

const it_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Caratteristica`
};

const nl_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Kenmerk`
};

const pl_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Cechy`
};

const pt_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Característica`
};

const sv_characteristic = /** @type {(inputs: {}) => string} */ () => {
	return `Egenskap`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const characteristic = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.characteristic(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("characteristic", locale)
	if (locale === "cs") return cs_characteristic(inputs)
	if (locale === "da") return da_characteristic(inputs)
	if (locale === "de") return de_characteristic(inputs)
	if (locale === "en") return en_characteristic(inputs)
	if (locale === "es") return es_characteristic(inputs)
	if (locale === "fr") return fr_characteristic(inputs)
	if (locale === "hu") return hu_characteristic(inputs)
	if (locale === "it") return it_characteristic(inputs)
	if (locale === "nl") return nl_characteristic(inputs)
	if (locale === "pl") return pl_characteristic(inputs)
	if (locale === "pt") return pt_characteristic(inputs)
	return sv_characteristic(inputs)
};